import React from 'react';
import CxInput from '../../cx/CxInput';
import CxSnackbar from '../../cx/CxSnackbar';
import CxButton from '../../cx/CxButton';
import CxPaper from '../../cx/CxPaper';
import { useTranslation } from '../../hx/useTranslation';
// eslint-disable-next-line no-unused-vars
import '../../../styles/main.css';
import GxForm from '../../gx/GxForm';
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import GxSearcherClient from '../../gx/GxSearcherClient';
import GxSearcherAnimal from '../../gx/GxSearcherAnimal';
import { isApp } from "../../gx/GxStore";
import GxIconButtonLastClient2 from '../../gx/GxIconButtonLastClient2';
import iberixSmilingPNG from '../../../assets/img/svg/iberix_smiling.jpg';
import iberixThinkingPNG from '../../../assets/img/svg/iberix_thinking.jpg';

const MxAiForm = (props) => {
  const [{ trans }] = useTranslation();

  let r_form = React.useRef(null);

  const rf_txClient = React.useRef(null);
  const rf_txAnimal = React.useRef(null);
  const rf_question = React.useRef(null);
  const rf_bn_send = React.useRef(null);
  const rf_response = React.useRef(null);

  const [response, setResponse] = React.useState('');
  const [disabled, setDisabled] = React.useState(false);
  const [iberixImage, setIberixImage] = React.useState(iberixSmilingPNG);

  const r_snack_required = React.useRef(null);
  const r_snack_error = React.useRef(null);

  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const doSend = () => {
    if (rf_txClient.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + trans('field.client'));
      r_snack_required.current.setOpen(true);
      return;
    }
    if ((isApp('vett') || isApp('spaw')) && rf_txAnimal.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + trans('field.patient'));
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_question.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + trans('field.ask'));
      r_snack_required.current.setOpen(true);
      return;
    }
    setResponse('');
    setDisabled(true);
    setIberixImage(iberixThinkingPNG);
    rf_response.current.setLoading(true);
    let record = {};
    record['inClient'] = rf_txClient.current.getKey();
    if (isApp('vett') || isApp('spaw')) {
      record['inAnimal'] = rf_txAnimal.current.getKey();
    }
    record['question'] = rf_question.current.getVal();
    Promise.all([FxFetch.doJsonX('chat_gpt/client', record)]).then((result) => {
      let rv = result[0];
      if (rv) {
        if (result[0].theStatus === 'error') {
          if (result[0].theValue === 'rv_chatgpt_usage_quota_has_been_exceeded') {
            r_snack_error.current.setValAndOpen(trans('msg.chatgpt_usage_quota_has_been_exceeded'));
          }
          if (result[0].theValue === 'rv_chatgpt_communication_error') {
            r_snack_error.current.setValAndOpen(trans('msg.chatgpt_communication_error'));
          }
          if (result[0].theValue === 'rv_chatgpt_error') {
            r_snack_error.current.setValAndOpen(trans('msg.chatgpt_error'));
          }
        } else {
          FxLog.infox('MxAiForm.doRequest', '...result[0]:', rv);
          setResponse(rv);
        }
        rf_question.current.clear();
      }
      setDisabled(false);
      rf_response.current.setLoading(false);
      setIberixImage(iberixSmilingPNG);
    });
  };

  return (
    <div>
      <GxForm
        moduleName={`IBERIX AI`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <GxIconButtonLastClient2 theClient={rf_txClient} theAnimal={rf_txAnimal} />
          </div>
        }
      >
        {/* Contenedor principal para los campos y la imagen */}
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '20px', flexWrap: 'wrap' }}>
          {/* Contenedor para los campos de entrada */}
          <div style={{ flex: '1 1 60%', minWidth: '300px' }}> {/* flex-grow, flex-shrink, flex-basis */}
            <div style={{ marginBottom: '10px' }}>
              <GxSearcherClient xref={rf_txClient} animalRef={rf_txAnimal} width='var(--ibs_control_width_lg)' disabled={disabled} required />
            </div>

            {(isApp('vett') || isApp('spaw')) && 
              <div style={{ marginBottom: '10px' }}>
                <GxSearcherAnimal xref={rf_txAnimal} clientRef={rf_txClient} width='var(--ibs_control_width_lg)' disabled={disabled} required />
              </div>
            }
            <CxInput xref={rf_question}
              label={trans('field.ask_about_the_x', (isApp('vett') || isApp('spaw')) ? `${trans('field.client')}/${trans('field.patient')}` : 'field.client')}
              onEnter={() => doSend()}
              onClear={() => setResponse('')}
              width='var(--ibs_control_width_lg)'
              disabled={disabled}
              minRows={3}
              speech
              required
            />
          </div>

          {/* Contenedor para la imagen */}
          <div style={{ flex: '1 1 30%', minWidth: '150px', display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
            <img
              src={iberixImage}
              alt="AI Illustration"
              style={{ maxWidth: '100%', height: 'auto', maxHeight: '250px' }} // Ajusta maxHeight si es necesario
            />
          </div>
        </div>

        <div style={{ width: '100%', textAlign: 'left', display: 'flex', flexDirection: 'row', flexFlow: 'row wrap', gap: '5px' }}>
          <CxButton xref={rf_bn_send} label={trans('field.send')} onClick={doSend} width='var(--ibs_control_width_lg)' disabled={disabled} />
        </div>

        <CxPaper
          xref={rf_response}
          responseText={response.theValue}
        />

      </GxForm>

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_error} severity="error" />

    </div>
  );
}

export default MxAiForm;